export default __webpack_public_path__ + "static/media/twitter.43b451a3.svg";